import { createApi } from '@reduxjs/toolkit/query/react';
import { userBaseQuery } from '../user/userBaseQuery';

export const userAuthApis = createApi({
    reducerPath: 'userAuthApis',
    baseQuery: userBaseQuery,
    refetchOnFocus: true,
    endpoints: (builder) => ({
        //POST /auth-attempt
        authAttempt: builder.mutation({
            query: (newPost) => ({
                url: 'auth-attempt',
                method: 'POST',
                body: newPost,
            })
        }),

        //POST /signin
        loginUser: builder.mutation({
            query: (newPost) => ({
                url: 'signin',
                method: 'POST',
                body: newPost,
            })
        }),

        //POST /auth-verify
        verifyUser: builder.mutation({
            query: (newPost) =>({
                url: 'auth-verify?platform=dev.datalyze.machinehack.com',
                method: 'POST',
                body:newPost,
            })
        }),

        //POST /signup
        signUpUser: builder.mutation({
            query: (newPost) => ({
                url: 'signup',
                method: 'POST',
                body: newPost,
            })
        })
    })
});

export const {
    useAuthAttemptMutation,
    useLoginUserMutation,
    useVerifyUserMutation,
    useSignUpUserMutation,
} = userAuthApis;